import { SetWorkbookDataModel } from "../Models/Excel/SetWorkbookDataModel";

export class ExcelDataService {
    public static setWorkbook(model: SetWorkbookDataModel, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/excel/setworkbook`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(model),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteUploadWorkbook(workbookId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/excel/upload/${workbookId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteProcessedWorkbook(workbookId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/excel/processed/${workbookId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteProcessedLineImpaCode(processedLineId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/excel/processed/line/${processedLineId}/impa`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }    
    
    public static doesFileExist(fileName: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/excel/doesfileexist/${fileName}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static canCreateEnquiryFromProcessedWorkbook(processedWorkbookId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/excel/processed/${processedWorkbookId}/cancreateenquiry`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}